import React from "react";
import { setPPID } from "../../actions/headerActions";
import { useDispatch, useSelector } from "react-redux";
import { socket } from "../../lib/socketio";
import { Menu, Dropdown } from "semantic-ui-react";
import User from "../Header/User";
import DropdownFilter from "./DropdownFilter";
import { useCookies } from "react-cookie";

const PPLTDropDown = () => {
  const user = useSelector((state) => state.nav.user);
  const userCopy = useSelector((state) => state.nav.userCopy);
  const [cookies] = useCookies(["HMI_FILTER"]);

  const [unitList, setUnitList] = React.useState([]);
  const [orgUnitList, setOrgUnitList] = React.useState([]);

  const dispatch = useDispatch();
  const fleet = useSelector((state) => state.fleet.fleet);

  // console.log('fleet',user, userCopy)

  React.useEffect(() => {
    const options = [];
    const actual_data = [];

    var text = "";
    let tableData = fleet;
    if (cookies.HMI_FILTER) {
      tableData = filterFleet(fleet, cookies.HMI_FILTER);
    }

    for (const f of tableData) {
      if (f.decommissioned == 0 && f.model_id === 2) {
        actual_data.push(f);
        if (f.designation_id != null) {
          text = `${f.powerplant_id} (${f.site_name}) #${f.designation_id}`;
        } else {
          text = `${f.powerplant_id} (${f.site_name})`;
        }
        const option = {
          key: f.powerplant_id,
          value: f.powerplant_id,
          text: text,
        };
        options.push(option);
      }

      setUnitList(options);
      setOrgUnitList(actual_data);
    }
  }, [fleet, cookies]);

  //join pplt
  const handleItemClick = (e, { value }) => {
    dispatch(setPPID(value));
    socket.emit("join pplt", {
      ppid: value.toString(),
      username: user.name,
      role: userCopy.hmi_role,
      plc: "MMON",
    });
  };

  return (
    <div>
      <Menu inverted style={styles.header}>
        <User />
      </Menu>

      <div style={styles.div}>
        <h1 style={{ paddingBottom: "3rem" }}>PowerPlant List</h1>
        <div style={styles.dropdown}>
          <Dropdown
            search
            selection
            clearable
            lazyLoad
            fluid
            label="Select PPLT"
            placeholder="Select your PPLT"
            options={unitList}
            onChange={handleItemClick}
            selectOnNavigation={false}
            selectOnBlur={false}
          />
          <DropdownFilter />
        </div>
      </div>
    </div>
  );
};

export const filterFleet = (fleet, filter) => {
  const entries = Object.entries(filter);
  return fleet.filter((row) =>
    entries.every(([key, value]) => value.includes(row[key])),
  );
};

const styles = {
  div: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: "1 1 auto",
    width: "100%",
  },
  header: {
    flexDirection: "row-reverse",
    position: "sticky",
    top: "0",
  },
  dropdown: {
    display: "flex",
    width: "100%",
    maxWidth: "590px",
    // width: '28rem',
  },
  addfilter: {
    margin: "0 0 0 20px",
    color: "red",
  },
  nofilter: {
    margin: "0 0 0 20px",
  },
  clearButton: {
    margin: "19px 37px 0 0",
  },
};

export default PPLTDropDown;
